<template>
  <Login v-if="currentRouteName === 'Login'" />
  <ForgottenPassword v-else-if="currentRouteName === 'ForgottenPassword'" />
  <SetNewPassword v-else-if="currentRouteName === 'SetNewPassword'" />
  <Register v-else-if="currentRouteName === 'Register'" />
  <AcceptLogin v-else-if="currentRouteName === 'AcceptLogin'" />
  <FirstSteps v-else-if="currentRouteName === 'FirstSteps'" />
  <Layout v-else />

  <div
    v-if="apiError"
    ref="apiError"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="row">
            <div class="col"></div>
            <div class="col-auto">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                :aria-label="$t(`scanModal.close`)"
              ></button>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <Vue3Lottie
                ref="icon"
                :animationData="iconJSON"
                :height="160"
                :width="160"
                :loop="false"
              />
            </div>
            <div class="col-12 text-center">
              <h1 class="bold-19">
                {{ apiError?.title !== undefined ? apiError?.title : "Error" }}
              </h1>
              <div class="regular-14 mb-4">
                {{ apiError?.message }}
                <ul v-if="apiError?.errors">
                  <li v-for="error in apiError.errors" :key="error">
                    {{ error[0] }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="position-fixed bottom-0 end-0 p-3 z-index-1070"
    v-if="apiSuccess || apiLoading?.length > 0"
  >
    <div
      ref="apiSuccess"
      class="toast hide"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="toast-header">
        <strong class="me-auto">Success</strong>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button>
      </div>
      <div class="toast-body">
        {{ apiSuccess?.message || "The changes have been saved" }}
      </div>
    </div>
    <template v-for="toast in apiLoading" :key="toast.key">
      <div
        class="toast show"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div class="toast-header">
          <div class="spinner-border text-primary me-3" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <strong class="me-auto">{{ toast.message }}</strong>
        </div>
      </div>
    </template>
  </div>
  <Modal
    v-if="modal !== null && modal !== undefined"
    v-model:component="modal.component"
    v-model:app-id="modal.appId"
    v-model:title="modal.title"
    v-model:data="modal.data"
    ref="modal"
  />
</template>
<script>
import { defineAsyncComponent } from "vue";
//import Layout from "./views/Layout";
const Layout = defineAsyncComponent(() => import("./views/Layout.vue"));
const Login = defineAsyncComponent(() => import("./views/login/Login.vue"));
const ForgottenPassword = defineAsyncComponent(() =>
  import("./views/login/ForgottenPassword.vue")
);
const SetNewPassword = defineAsyncComponent(() =>
  import("./views/login/SetNewPassword.vue")
);
const Register = defineAsyncComponent(() =>
  import("./views/login/Register.vue")
);
const AcceptLogin = defineAsyncComponent(() =>
  import("./views/login/AcceptLogin.vue")
);
const FirstSteps = defineAsyncComponent(() =>
  import("./views/login/FirstSteps.vue")
);
import { useStore } from "vuex";
import Modal from "@/components/modals/Modal";
import { Vue3Lottie } from "vue3-lottie";
import errorJSON from "./assets/animations/error.json";
import TimeTracking from "./modules/TimeTracking";

const bootstrap = require("bootstrap");

export default {
  components: {
    FirstSteps,
    Modal,
    AcceptLogin,
    Register,
    SetNewPassword,
    ForgottenPassword,
    Login,
    Layout,
    Vue3Lottie,
  },
  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
  data() {
    const store = useStore();
    return {
      store: store,
      modal: null,
      iconJSON: errorJSON,
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    apiError() {
      return this.store.state.apiError;
    },
    apiSuccess() {
      return this.store.state.apiSuccess;
    },
    apiLoading() {
      return this.store.state.apiLoading;
    },
    lastModal() {
      return this.store.state.lastModal;
    },
    language() {
      return this.store.state.user?.language_code;
    },
  },
  watch: {
    lastModal() {
      if (this.modal !== null && this.lastModal === null) {
        this.$refs.modal.hideModal();
      } else {
        this.modal = this.lastModal;
      }
    },
    language() {
      if (this.language) {
        this.$i18n.locale = this.language;
      }
    },
    apiError() {
      if (this.apiError) {
        setTimeout(() => {
          // one instance per element: a second `new Modal` adds a second backdrop
          // that closing the dialog leaves behind
          bootstrap.Modal.getOrCreateInstance(this.$refs.apiError).show();
        }, 400);
      }
    },
    apiSuccess() {
      if (this.apiSuccess) {
        setTimeout(() => {
          bootstrap.Toast.getOrCreateInstance(this.$refs.apiSuccess).show();
        }, 400);
      }
    },
  },
  mounted() {
    TimeTracking.clearSynced();
    window.addEventListener("pagehide", () => {
      if (!TimeTracking.isTracking()) return;
      TimeTracking.stop();
      TimeTracking.syncEntries(true);
    });

    setInterval(() => {
      TimeTracking.syncEntries();
    }, 60000);
  },
};
</script>
